const endpoints = {
  listStrategy: (): string => `strategy`,
};

export default endpoints;
